<template>
  <b-container fluid>
    <b-alert :show="alert.show" :variant="alert.variant" class="mt-2" fade>
      {{alert.message}}
    </b-alert>
    <h1>AM Advantage Ineligible Items</h1>
    <b-row align-h="center">
      <b-col class="my-1" cols=4>
          <b-input-group>
            <b-form-input v-model="input" @keydown.enter=onFilter placeholder="Type to Search" />
            <b-input-group-append>
              <b-button variant="primary" @click=onFilter>Search</b-button>
              <b-button variant=warning :disabled="!input" @click="input = '' && onFilter()">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
      </b-col>
      <b-col class="my-1" cols=1>
        <b-btn variant=primary @click="getData" class="mb-0">
          Reload
        </b-btn>
      </b-col>
      <b-col cols=3>
      </b-col>
    </b-row>
    <b-row align-h="center">
      <b-col class="my-1" cols=8>
        <table class="table b-table">
          <thead>
            <tr>
              <th>Part Num</th>
              <th>Description</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody v-if="busy" class="table">
            <tr>
              <center>
                <fingerprint-spinner :animation-duration="1500" :size="300" color="#293a93" class="align-middle" />
              </center>
            </tr>
          </tbody>
          <tbody v-else>
            <tr v-for="item in filteredItems" :key="item.partnum">
              <td>{{ item.partnum }}</td>
              <td>{{ item.description }}</td>
              <td>
                <b-button variant="danger" @click="onDelete(item)">
                  Delete
                </b-button>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>
    <b-row align-h="center">
      <b-col class="pt-2" cols=3>
        <center><h3>Add Ineligible Item</h3></center>
        <b-form @submit="onSubmitForm">
          <b-form-row>
            <b-col cols=4>Product Number:</b-col>
            <b-col><b-form-input v-model="form.num" /></b-col>
          </b-form-row>
          <center>
            <b-btn variant="primary" class="mt-2" type="submit">
              Add Ineligible Item
            </b-btn>
          </center>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from 'axios';
import { FingerprintSpinner } from 'epic-spinners';
const BASE_API = `${process.env.VUE_API_ROOT}/am-old-db/adv-ineligible`;

export default {
  data() {
    return {
      items: [],
      filteredItems: [],
      busy: true,
      input: '',
      filter: '',
      fields: [
        { key: 'partnum', label: 'Part Number', sortable: true },
        'description', 'actions'
      ],
      form: {},
      alert: { show: false, message: '', variant: 'info' },
    };
  },
  components: {
    FingerprintSpinner
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.busy = true;
      axios.get(`${BASE_API}/`).then(response => {
        this.items = response.data;
        this.onFilter();
      });
    },
    onFilter(evt) {
      if (!!evt) evt.preventDefault();

      this.busy = true
      this.filteredItems = this.items.filter(x =>
        (!!x.partnum && x.partnum.includes(this.input)) ||
        (!!x.description && x.description.includes(this.input))
      )
      this.busy = false
    },
    onDelete(item) {
      this.alert = { message: 'Request Sent', variant: 'info', show: true };
      axios({
        method: 'delete',
        url: `${BASE_API}/${item.partnum}`,
      }).then(response => {
        this.alert = { message: 'Item Deleted.', variant: 'success', show: 3 };
        this.getData();
      }).catch((error) => {
        console.error(error);
        if (error.response) {
          console.error(error.response);
          this.alert = { message: error.response.data, variant: 'danger', show: 3 };
        } else {
          this.alert = { message: 'Failed to Delete Item', variant: 'danger', show: 3 };
        }
      })
    },
    onSubmitForm(event) {
      event.preventDefault();
      this.alert = { message: 'Request Sent', variant: 'info', show: true };

      axios({
        method: 'post',
        headers: { 'Content-Type': 'text/plain' },
        url: `${BASE_API}/`,
        data: this.form,
      }).then(response => {
        this.alert = { message: 'Item Added.', variant: 'success', show: 3 };
        this.getData();
      }).catch((error) => {
        console.error(error);
        if (error.response) {
          this.alert = { message: error.response.data, variant: 'danger', show: 3 };
        } else {
          this.alert = { message: 'Failed to Add Item', variant: 'danger', show: 3 };
        }
      })
    },
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ops-info/AdvIneligible.vue